import { FormProvider } from 'react-hook-form';

import { ButtonType } from '@xemplo/button';
import { HeaderIconMode } from '@xemplo/header-icon';
import { DawnPeoplePlus } from '@xemplo/icons';
import { Modal, ModalDialogSlot } from '@xemplo/modal-dialog';

import { CreateCompanyUserForm } from './form/create-company-user-form';
import { useCreateCompanyUserForm } from './form/use-create-company-user-form';
import { CreateCompanyUserProps } from './create-company-user.types';
import { CreateCompanyUserButton } from './create-company-user-button';

export function CreateCompanyUser({
  companyId,
  renderButton,
  onSuccess,
}: Readonly<CreateCompanyUserProps>) {
  const { form, modal, handleCancel, handleSubmit } = useCreateCompanyUserForm({
    companyId,
    onSuccess,
  });

  return (
    <>
      <CreateCompanyUserButton
        onClick={() => modal.openModalDialog()}
        renderButton={renderButton}
      />

      <Modal.Dialog {...modal.dialogProps}>
        {modal.isOpen ? (
          <Modal>
            <Modal.Slot
              name={ModalDialogSlot.CloseButton}
              render={
                <Modal.CloseButton
                  onClick={handleCancel}
                  id="create-company-user-close-button"
                  ariaLabel="Close create company user modal"
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Header}
              render={
                <Modal.Header
                  title="New user"
                  headerIcon={{
                    icon: <DawnPeoplePlus />,
                    mode: HeaderIconMode.Object,
                  }}
                />
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Body}
              render={
                <Modal.Body>
                  <FormProvider {...form}>
                    <CreateCompanyUserForm />
                  </FormProvider>
                </Modal.Body>
              }
            />
            <Modal.Slot
              name={ModalDialogSlot.Footer}
              render={
                <Modal.Footer
                  btnPrimary={{
                    onClickAsync: handleSubmit,
                    label: 'Create user',
                    ariaLabel: 'Submit create company user form',
                    type: ButtonType.Primary,
                  }}
                  btnTertiary={{
                    onClick: handleCancel,
                    label: 'Cancel',
                    ariaLabel: 'Cancel create company user',
                    type: ButtonType.Tertiary,
                  }}
                />
              }
            />
          </Modal>
        ) : null}
      </Modal.Dialog>
    </>
  );
}

export default CreateCompanyUser;
